import * as React from "react";
import { Loader } from "lucide-react";
import { useAuth } from "../../providers/AuthProvider";
import { useAutoOpenTaskpane } from "../hooks/useAutoOpenTaskpane";

const AuthFlow = React.lazy(() => import("./auth"));
const AuthenticatedScreen = React.lazy(() => import("./AuthenticatedScreen"));

const App: React.FC = () => {
  const { isAuthenticated, isLoading, isError } = useAuth();

  useAutoOpenTaskpane();

  return (
    <div
      className="flex flex-col h-screen"
      role="application"
      aria-label="Legal Assistant AI Add-in"
    >
      {isLoading ? (
        <div className="flex flex-col items-center justify-center h-screen gap-4">
          <Loader className="animate-spin" size={48} />
          <p>Loading...</p>
        </div>
      ) : (
        <main id="main-content" className="h-full" role="main">
          <React.Suspense
            fallback={
              <div className="flex flex-col items-center justify-center h-screen gap-4">
                <Loader className="animate-spin" size={48} />
                <p>Loading...</p>
              </div>
            }
          >
            {!isAuthenticated || isError ? (
              <div className="py-4 px-4">
                <AuthFlow />
              </div>
            ) : (
              <AuthenticatedScreen />
            )}
          </React.Suspense>
        </main>
      )}
    </div>
  );
};

export default App;
